import { systemDetailRoute } from './system';

export const exportSystemBaseRoute = 'export';
export const exportSystemModalChooseOptionRoute = `${systemDetailRoute}/${exportSystemBaseRoute}`;
export const exportSystemModalDestinationTypeRoute = `${exportSystemModalChooseOptionRoute}/:type`;
